export interface VideoCategory {
  slug: string;
  name: string;
  icon: string;
}

export interface VideoItem {
  id: string;
  slug: string;
  title: string;
  thumbnail: string;
  duration: string;
  category: string;
  categorySlug: string;
  views: number;
  rating: number;
  updateTime: string;
  description: string;
  tags: string[];
  source: string;
  featured: boolean;
}

export const videoCategories: VideoCategory[] = [
  { slug: 'all', name: '全部', icon: 'ri-apps-line' },
  { slug: 'tv-series', name: '电视剧', icon: 'ri-tv-line' },
  { slug: 'movies', name: '电影', icon: 'ri-film-line' },
  { slug: 'anime', name: '动漫', icon: 'ri-rocket-line' },
  { slug: 'variety', name: '综艺', icon: 'ri-live-line' },
  { slug: 'documentary', name: '纪录片', icon: 'ri-earth-line' },
  { slug: 'shorts', name: '短视频', icon: 'ri-vidicon-line' },
  { slug: 'kids', name: '少儿', icon: 'ri-heart-line' },
];

export const videos: VideoItem[] = [
  {
    id: 'v001',
    slug: 'qing-yu-nian-2',
    title: '庆余年第二季',
    thumbnail: 'https://readdy.ai/api/search-image?query=Chinese%20historical%20drama%20scene%20with%20ancient%20palace%20and%20figures%20in%20traditional%20robes%2C%20cinematic%20lighting%2C%20warm%20golden%20tones%2C%20epic%20composition%2C%20high%20detail%2C%20professional%20film%20poster%20style&width=640&height=360&seq=mitao-v001&orientation=landscape',
    duration: '45:00',
    category: '电视剧',
    categorySlug: 'tv-series',
    views: 15230000,
    rating: 9.2,
    updateTime: '2026-08-01',
    description: '《庆余年第二季》延续第一季剧情，范闲在京都面临更加复杂的权力斗争，他与林婉儿、海棠朵朵等人的命运交织，朝堂之上的明争暗斗愈演愈烈。',
    tags: ['古装', '权谋', '热门', '张若昀'],
    source: '香蕉视频',
    featured: true,
  },
  {
    id: 'v002',
    slug: 'liu-lang-di-qiu-3',
    title: '流浪地球3',
    thumbnail: 'https://readdy.ai/api/search-image?query=Epic%20sci-fi%20movie%20scene%20with%20Earth%20in%20space%20and%20giant%20engines%2C%20futuristic%20technology%2C%20blue%20and%20orange%20cosmic%20glow%2C%20cinematic%20film%20poster%20style%2C%20high%20detail%2C%20dramatic%20composition&width=640&height=360&seq=mitao-v002&orientation=landscape',
    duration: '138:00',
    category: '电影',
    categorySlug: 'movies',
    views: 28900000,
    rating: 8.9,
    updateTime: '2026-07-30',
    description: '《流浪地球3》讲述太阳即将毁灭，人类在地球表面建造出巨大的推进器，寻找新的家园。第三部中，人类面临前所未有的危机与抉择。',
    tags: ['科幻', '灾难', '热门', '吴京'],
    source: '糖豆视频',
    featured: true,
  },
  {
    id: 'v003',
    slug: 'fan-hua',
    title: '繁花',
    thumbnail: 'https://readdy.ai/api/search-image?query=1990s%20Shanghai%20street%20scene%20with%20neon%20lights%20and%20vintage%20cars%2C%20nostalgic%20atmosphere%2C%20warm%20golden%20lighting%2C%20film%20noir%20style%2C%20Chinese%20period%20drama%20poster%2C%20elegant%20composition&width=640&height=360&seq=mitao-v003&orientation=landscape',
    duration: '50:00',
    category: '电视剧',
    categorySlug: 'tv-series',
    views: 21000000,
    rating: 9.4,
    updateTime: '2026-07-29',
    description: '《繁花》由王家卫执导，胡歌、马伊琍、唐嫣主演，讲述上世纪九十年代初的上海，阿宝从普通人到宝总的人生传奇故事。',
    tags: ['都市', '年代', '经典', '胡歌'],
    source: '小蓝视频',
    featured: true,
  },
  {
    id: 'v004',
    slug: 'chang-an-san-wan-li',
    title: '长安三万里',
    thumbnail: 'https://readdy.ai/api/search-image?query=Ancient%20Tang%20Dynasty%20Changan%20cityscape%20at%20sunset%2C%20traditional%20architecture%20with%20flying%20eaves%2C%20poetic%20atmosphere%2C%20animated%20film%20style%2C%20warm%20golden%20tones%2C%20beautiful%20Chinese%20art&width=640&height=360&seq=mitao-v004&orientation=landscape',
    duration: '168:00',
    category: '动漫',
    categorySlug: 'anime',
    views: 18700000,
    rating: 8.7,
    updateTime: '2026-07-28',
    description: '《长安三万里》以唐代为背景，讲述高适与李白跨越数十年的友情故事，展现大唐盛世的辉煌与诗人的浪漫情怀。',
    tags: ['动画', '历史', '诗歌', '追光动画'],
    source: '糖豆视频',
    featured: true,
  },
  {
    id: 'v005',
    slug: 'kuang-biao',
    title: '狂飙',
    thumbnail: 'https://readdy.ai/api/search-image?query=Chinese%20crime%20drama%20scene%20with%20police%20officer%20in%20dark%20alley%2C%20noir%20lighting%2C%20tense%20atmosphere%2C%20dramatic%20composition%2C%20TV%20series%20poster%20style%2C%20high%20contrast&width=640&height=360&seq=mitao-v005&orientation=landscape',
    duration: '48:00',
    category: '电视剧',
    categorySlug: 'tv-series',
    views: 35600000,
    rating: 9.5,
    updateTime: '2026-07-27',
    description: '《狂飙》讲述刑警安欣与黑恶势力长达二十年的较量，展现了扫黑除恶斗争的艰辛与复杂，张译、张颂文领衔主演。',
    tags: ['犯罪', '悬疑', '热门', '张译'],
    source: '香蕉视频',
    featured: false,
  },
  {
    id: 'v006',
    slug: 'man-jiang-hong',
    title: '满江红',
    thumbnail: 'https://readdy.ai/api/search-image?query=Ancient%20Chinese%20courtyard%20at%20night%20with%20lanterns%2C%20historical%20mystery%20atmosphere%2C%20red%20and%20dark%20tones%2C%20cinematic%20film%20poster%2C%20Song%20Dynasty%20aesthetic%2C%20dramatic%20lighting&width=640&height=360&seq=mitao-v006&orientation=landscape',
    duration: '159:00',
    category: '电影',
    categorySlug: 'movies',
    views: 41200000,
    rating: 8.5,
    updateTime: '2026-07-26',
    description: '《满江红》由张艺谋执导，沈腾、易烊千玺主演，南宋绍兴年间，岳飞死后四年，秦桧率兵与金国会谈，一群义士设局刺杀的故事。',
    tags: ['历史', '悬疑', '喜剧', '沈腾'],
    source: '蓝莓视频',
    featured: false,
  },
  {
    id: 'v007',
    slug: 'bai-she-yuan-qi',
    title: '白蛇：缘起',
    thumbnail: 'https://readdy.ai/api/search-image?query=Chinese%20animated%20film%20scene%20with%20white%20snake%20fairy%20in%20ancient%20landscape%2C%20misty%20mountains%2C%20romantic%20atmosphere%2C%20traditional%20Chinese%20art%20style%2C%20ethereal%20beauty%2C%20soft%20lighting&width=640&height=360&seq=mitao-v007&orientation=landscape',
    duration: '99:00',
    category: '动漫',
    categorySlug: 'anime',
    views: 12500000,
    rating: 8.8,
    updateTime: '2026-07-25',
    description: '《白蛇：缘起》讲述白素贞在五百年前与许仙的前身阿宣之间一段刻骨铭心的爱情故事，画面精美，情感真挚。',
    tags: ['动画', '爱情', '奇幻', '国漫'],
    source: '小蓝视频',
    featured: false,
  },
  {
    id: 'v008',
    slug: 'cheng-feng-po-lang-2026',
    title: '乘风破浪的姐姐2026',
    thumbnail: 'https://readdy.ai/api/search-image?query=Chinese%20variety%20show%20stage%20with%20female%20performers%20in%20glamorous%20costumes%2C%20concert%20lighting%2C%20energetic%20atmosphere%2C%20colorful%20stage%20design%2C%20entertainment%20show%20poster%20style&width=640&height=360&seq=mitao-v008&orientation=landscape',
    duration: '120:00',
    category: '综艺',
    categorySlug: 'variety',
    views: 9800000,
    rating: 8.3,
    updateTime: '2026-07-24',
    description: '《乘风破浪的姐姐2026》全新一季重磅回归，多位实力女艺人集结，通过舞台竞演展现女性魅力与力量。',
    tags: ['综艺', '音乐', '竞技', '女性'],
    source: '蓝莓视频',
    featured: false,
  },
  {
    id: 'v009',
    slug: 'di-qiu-mai-dong',
    title: '地球脉动·中国篇',
    thumbnail: 'https://readdy.ai/api/search-image?query=Chinese%20natural%20landscape%20documentary%20scene%20with%20mountains%20and%20wildlife%2C%20aerial%20view%2C%20stunning%20nature%20photography%2C%20warm%20sunlight%2C%20professional%20documentary%20style%2C%20breathtaking%20scenery&width=640&height=360&seq=mitao-v009&orientation=landscape',
    duration: '55:00',
    category: '纪录片',
    categorySlug: 'documentary',
    views: 6700000,
    rating: 9.6,
    updateTime: '2026-07-23',
    description: '《地球脉动·中国篇》以震撼的4K画面记录中国广袤大地上的自然奇观与野生动物，从青藏高原到南海岛屿，展现中国生态之美。',
    tags: ['纪录片', '自然', '中国', '4K'],
    source: '糖豆视频',
    featured: true,
  },
  {
    id: 'v010',
    slug: 'yi-nian-guan-shan',
    title: '一念关山',
    thumbnail: 'https://readdy.ai/api/search-image?query=Chinese%20martial%20arts%20drama%20scene%20in%20ancient%20setting%2C%20warriors%20in%20traditional%20attire%2C%20epic%20battle%20atmosphere%2C%20warm%20golden%20lighting%2C%20film%20poster%20style%2C%20dramatic%20composition&width=640&height=360&seq=mitao-v010&orientation=landscape',
    duration: '46:00',
    category: '电视剧',
    categorySlug: 'tv-series',
    views: 14300000,
    rating: 8.6,
    updateTime: '2026-07-22',
    description: '《一念关山》由刘诗诗、刘宇宁主演，讲述女侠任如意与六道堂主宁远舟共同经历生死考验，守护家国的传奇故事。',
    tags: ['武侠', '古装', '爱情', '刘诗诗'],
    source: '香蕉视频',
    featured: false,
  },
  {
    id: 'v011',
    slug: 'gu-dan-yi-zhi',
    title: '孤胆义志',
    thumbnail: 'https://readdy.ai/api/search-image?query=Chinese%20action%20movie%20scene%20with%20lone%20hero%20in%20urban%20setting%2C%20explosive%20action%2C%20dramatic%20lighting%2C%20modern%20thriller%20aesthetic%2C%20film%20poster%20style%2C%20high%20intensity&width=640&height=360&seq=mitao-v011&orientation=landscape',
    duration: '125:00',
    category: '电影',
    categorySlug: 'movies',
    views: 8700000,
    rating: 8.1,
    updateTime: '2026-07-21',
    description: '《孤胆义志》讲述一名退役特工为保护证人，独自对抗整个犯罪集团的热血动作大片，打戏精彩，节奏紧凑。',
    tags: ['动作', '犯罪', '热血', '新片'],
    source: '小蓝视频',
    featured: false,
  },
  {
    id: 'v012',
    slug: 'dou-luo-da-lu-2',
    title: '斗罗大陆2：绝世唐门',
    thumbnail: 'https://readdy.ai/api/search-image?query=Chinese%203D%20animated%20fantasy%20scene%20with%20magical%20battle%2C%20colorful%20energy%20effects%2C%20fantasy%20world%20setting%2C%20anime%20style%20poster%2C%20epic%20magical%20atmosphere%2C%20vibrant%20visuals&width=640&height=360&seq=mitao-v012&orientation=landscape',
    duration: '22:00',
    category: '动漫',
    categorySlug: 'anime',
    views: 25600000,
    rating: 8.4,
    updateTime: '2026-07-20',
    description: '《斗罗大陆2：绝世唐门》延续斗罗系列世界观，讲述霍雨浩在史莱克学院的成长故事，全新冒险震撼开启。',
    tags: ['动画', '玄幻', '热血', '国漫'],
    source: '糖豆视频',
    featured: false,
  },
  {
    id: 'v013',
    slug: 'xi-huan-ni',
    title: '喜欢你我也是',
    thumbnail: 'https://readdy.ai/api/search-image?query=Chinese%20dating%20reality%20show%20scene%20with%20young%20couples%20in%20romantic%20setting%2C%20warm%20lighting%2C%20modern%20villa%20interior%2C%20reality%20TV%20poster%20style%2C%20sweet%20atmosphere&width=640&height=360&seq=mitao-v013&orientation=landscape',
    duration: '90:00',
    category: '综艺',
    categorySlug: 'variety',
    views: 7400000,
    rating: 7.9,
    updateTime: '2026-07-19',
    description: '《喜欢你我也是》是一档青年社交观察恋爱综艺，通过记录都市男女的真实相处，探讨当代年轻人的恋爱观念。',
    tags: ['综艺', '恋爱', '真人秀', '都市'],
    source: '蓝莓视频',
    featured: false,
  },
  {
    id: 'v014',
    slug: 'san-ti-dong-hua',
    title: '三体·动画版',
    thumbnail: 'https://readdy.ai/api/search-image?query=Chinese%20sci-fi%20animated%20scene%20with%20cosmic%20space%20and%20alien%20civilization%2C%20dark%20universe%20aesthetic%2C%20futuristic%20technology%2C%20three%20body%20problem%20theme%2C%20anime%20style%2C%20epic%20scale&width=640&height=360&seq=mitao-v014&orientation=landscape',
    duration: '30:00',
    category: '动漫',
    categorySlug: 'anime',
    views: 19200000,
    rating: 9.0,
    updateTime: '2026-07-18',
    description: '《三体·动画版》改编自刘慈欣科幻巨著，以精美动画呈现人类文明与三体文明的首次接触，视觉效果震撼。',
    tags: ['动画', '科幻', '刘慈欣', '国漫之光'],
    source: '小蓝视频',
    featured: true,
  },
  {
    id: 'v015',
    slug: 'chang-jin-hu-2',
    title: '长津湖之水门桥',
    thumbnail: 'https://readdy.ai/api/search-image?query=Chinese%20war%20movie%20scene%20in%20snowy%20mountain%20setting%2C%20soldiers%20in%20winter%20battle%2C%20epic%20war%20cinematography%2C%20cold%20blue%20and%20white%20tones%2C%20dramatic%20film%20poster%2C%20heroic%20atmosphere&width=640&height=360&seq=mitao-v015&orientation=landscape',
    duration: '149:00',
    category: '电影',
    categorySlug: 'movies',
    views: 38900000,
    rating: 9.1,
    updateTime: '2026-07-17',
    description: '《长津湖之水门桥》以抗美援朝战争第二次战役中的长津湖战役为背景，讲述志愿军七连战士在极端严寒条件下英勇作战的故事。',
    tags: ['战争', '历史', '爱国', '吴京'],
    source: '香蕉视频',
    featured: false,
  },
  {
    id: 'v016',
    slug: 'mei-shi-tan-suo',
    title: '风味人间·寻味中华',
    thumbnail: 'https://readdy.ai/api/search-image?query=Chinese%20food%20documentary%20scene%20with%20delicious%20traditional%20dishes%2C%20warm%20kitchen%20atmosphere%2C%20steaming%20hot%20food%2C%20beautiful%20food%20photography%2C%20cultural%20cuisine%20style%2C%20rich%20colors&width=640&height=360&seq=mitao-v016&orientation=landscape',
    duration: '50:00',
    category: '纪录片',
    categorySlug: 'documentary',
    views: 8900000,
    rating: 9.3,
    updateTime: '2026-07-16',
    description: '《风味人间·寻味中华》走遍中国大江南北，探索各地独特美食文化，用镜头记录人间烟火与饮食传承。',
    tags: ['纪录片', '美食', '文化', '陈晓卿'],
    source: '糖豆视频',
    featured: false,
  },
];

export const featuredVideos = videos.filter(v => v.featured);
export const latestVideos = [...videos].sort((a, b) => new Date(b.updateTime).getTime() - new Date(a.updateTime).getTime());
export const popularVideos = [...videos].sort((a, b) => b.views - a.views);